import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { db } from '..'
import { ref, get, update } from 'firebase/database'
import { useNavigate } from 'react-router-dom'

const AcceptEditorAuth = ({userData}) => {
    // URLパラメータ取得
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const key = searchParams.get('key'); 
    const [gameData, setGameData] = React.useState(null);
    const [error, setError] = React.useState(null);
    const navigate = useNavigate();

    // keyを使ってRealtime Databaseからデータを取得する処理
    useEffect(() => {
        const fetchData = async () => {
            const dataRef = ref(db, 'shareToEdit/' + key);
            const snapshot = await get(dataRef);
            if (snapshot.exists()) {
                setGameData(snapshot.val()); // データをstateに保存
            } else {
                setError("ゲームが見つかりませんでした"); // データがない場合のエラーハンドリング
            }
        };

        fetchData();
        
    }, [key]); // keyが変更されたときに再実行

    // 承諾ボタンが押されたときの処理
    const accept = async () => {
        if (!gameData) {
            setError("ゲームデータが取得できませんでした");
            return;
        }

        try {
            // 作成ゲームリストに追加（オブジェクトマップ形式。EditGame.jsxの保存形式と合わせる）
            const userRef = ref(db, 'users/' + userData.uid);
            await update(userRef, {
                ['createdGames/' + gameData.gameID]: gameData.gameID,
            });

            // 成功メッセージ
            alert("招待を承諾しました");

            // トップ画面に遷移
            navigate('/');
        } catch (error) {
            console.error("Error accepting editor invitation:", error);
            setError("招待の承諾に失敗しました");
        }
    };


    return (
        <div className='my-4 px-3 max-w-2xl mx-auto pt-6 mb-3'>
            <h2 className='text-center text-2xl mb-6'>編集者として招待を受ける</h2>
            
            {/* 招待の情報 */}
            {gameData && (
                <div className='bg-white shadow-sm rounded-lg p-4 mb-6'>
                    <h3 className='text-xl '>{gameData.name}</h3>
                    <p className='text-gray-700'>ゲームID: {gameData.gameID}</p>
                    <p className='text-gray-700'>招待者: {gameData.username}</p>
                    <p className='text-gray-700'>招待日時: {new Date(gameData.date).toLocaleString()}</p>
                </div>
            )}

            {/* 承諾ボタン */}
            <button className='block text-center rounded-lg bg-purple-500 hover:bg-purple-600 p-2 w-full text-white text-lg mt-4' onClick={() => accept()} >
                <i className='bi bi-check-lg me-2'></i>承諾する
            </button>

            {/* エラー */}
            {error && <p className='text-red-700 bg-red-100 p-2 rounded-md text-base mt-4'><i className='bi bi-exclamation-triangle mx-2'></i>{error}</p>}
        </div>
    )
}

export default AcceptEditorAuth